import React from "react";

const { Provider, Consumer } = React.createContext({});

export { Provider as LinkListProvider };
export { Consumer as LinkListConsumer };
